import { Badge } from "./ui/badge";

const ESTADO_STYLES = {
  Nueva: "bg-accent-info/15 text-accent-info border-accent-info/30",
  Asignada: "bg-valoriza-dark/15 text-valoriza-dark border-valoriza-dark/30 dark:text-emerald-300 dark:border-emerald-500/30",
  "En curso": "bg-accent-warning/15 text-accent-warning border-accent-warning/40",
  Resuelta: "bg-valoriza-leaf/15 text-valoriza-leaf border-valoriza-leaf/40",
  Verificada: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30 dark:text-emerald-300",
  Cerrada: "bg-muted text-muted-foreground border-border",
  Rechazada: "bg-accent-alert/15 text-accent-alert border-accent-alert/30",
  Duplicada: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ estado }) {
  return (
    <Badge
      data-testid={`status-badge-${estado?.toLowerCase().replace(/\s+/g, "-")}`}
      variant="outline"
      className={`${ESTADO_STYLES[estado] || "bg-muted"} font-bold text-[11px] uppercase tracking-wide rounded-sm`}
    >
      {estado}
    </Badge>
  );
}
